import TeamArt from "../../../assets/imgs/team-art.svg";

const UserList = ({
  title,
  users,
  message,
  onboardingMode = false,
}) => (
  <div className="mb-4 w-full">
    <h3
      className={`font-bold text-lg mb-2 ${
        onboardingMode ? "text-white dark:text-white" : ""
      }`}
    >
      {title}
    </h3>
    <p
      className={`mb-2 ${
        onboardingMode ? "text-white dark:text-white" : ""
      }`}
    >
      {message}
    </p>
    <ul
      className={`list-none ${
        onboardingMode
          ? "bg-transparent border border-white/20"
          : "bg-secondary border border-primary"
      } rounded-standard py-sm px-md w-full max-w-full`}
    >
      {users.map((user, index) => (
        <li
          key={index}
          className={`font-semibold text-primary w-full ${
            onboardingMode ? "text-white dark:text-white" : ""
          }`}
          title={user?.email}
        >
          {user?.email}
          {!user?.success && user?.reason && (
            <ul
              className={`list-disc list-inside ${
                onboardingMode ? "text-white dark:text-white" : ""
              }`}
            >
              <li className="text-danger">{user.reason}</li>
            </ul>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const NewUsersReceipt = ({
  receiptData,
  isPartOfOrganization,
  onboardingMode = false,
}) => {
  let { existing, newUsers } = receiptData;

  const messageNewUsers = isPartOfOrganization
    ? "These users have had accounts created automatically and were added to your team:"
    : "These users have been invited to create a Scribenote account and join your team:";

  const messageExistingUsers = isPartOfOrganization
    ? "These Scribenote users were added to your team:"
    : "These Scribenote users were invited to join your team:";

  const failedUsers = [
    ...(newUsers || []),
    ...(existing || []),
  ].filter((u) => !u.success);
  newUsers = (newUsers || []).filter((u) => u.success);
  existing = (existing || []).filter((u) => u.success);

  return (
    <div className="flex flex-row items-center space-x-4 w-full overflow-hidden">
      <img
        src={TeamArt}
        className="w-[250px] object-contain"
        alt="Team Art"
      />
      <div className="flex-1 overflow-hidden">
        {newUsers?.length > 0 && (
          <UserList
            title={`New Scribenote Users ${
              isPartOfOrganization ? "Added" : "Invited"
            }`}
            users={newUsers}
            message={messageNewUsers}
            onboardingMode={onboardingMode}
          />
        )}

        {existing?.length > 0 && (
          <UserList
            title={`Existing Scribenote Users ${
              isPartOfOrganization ? "Added" : "Invited"
            }`}
            users={existing}
            message={messageExistingUsers}
            onboardingMode={onboardingMode}
          />
        )}

        {failedUsers?.length > 0 && (
          <UserList
            title={`Failed invites`}
            users={failedUsers}
            message={"These invites failed to send"}
            onboardingMode={onboardingMode}
          />
        )}
      </div>
    </div>
  );
};

export default NewUsersReceipt;
